import { format } from "date-fns";
import { useFila } from "../../../../../context/FilaContext";
import { ClienteInfo } from "../cliente-info";

export const InfoChamada = () => {
  const { devedorFilaSelected } = useFila()



  return (
    <div className="my-4 min-h-max">
      <ClienteInfo />
      <div className=" rounded-md border  p-2">
        <strong className=" my-4 font-bold ">Informações Callback</strong>
        <div className="my-4 grid w-[80%] grid-cols-2 grid-rows-3">
          <p className="info-text">Data: {format(new Date(devedorFilaSelected?.date_origin), 'dd/MM/yyyy HH:mm:ss')}</p>
          <p className="info-text">Credor: {devedorFilaSelected?.credor?.credor_crm} - {devedorFilaSelected?.credor?.name_credor}</p>
          <p className="info-text">Canal: {devedorFilaSelected.channel?.channel}</p>
          <p className="info-text">Tipo Situação: {devedorFilaSelected?.reason?.desc_reason}</p>
          <p></p>
        </div>
      </div>
    </div>
  );
};
